export default {
    'pickerConfig': {
        'shortcuts': [
            { 'type': 'd', 'num': 30, 'text': '最近一个月', 'translate': 'component.E202007300013' },
            { 'type': 'd', 'num': 90, 'text': '最近三个月', 'translate': 'component.E202007300013' },
            { 'type': 'd', 'num': 180, 'text': '最近半年', 'translate': 'component.E202007300013' }
        ]
    },
    searchList: {
        searchTxt: [
            {
                name: '查询地址',
                value: 'address',
                type: 'input',
                unfold: true,
                span: 12
            },
            {
                name: '纠错时间',
                value: 'searchBeginTime',
                type: 'time',
                unfold: true,
                timeNum: 30,
                span: 8
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    configuration: true,
    table: {
        clickModify: false,
        selectBtn: false,
        leftOperation: false,
        height: 200,
        leftWidth: 170,
        actions: [],
        columns: [
            {
                label: '纠错人',
                align: 'center',
                prop: 'createUserCode',
                width: 120,
                sort: true
            },

            {
                label: '纠错时间',
                align: 'center',
                prop: 'createTime',
                width: 150,
                sort: true
            },
            {
                label: '省',
                align: 'center',
                prop: 'province',
                width: 100,
                sort: true
            },
            {
                label: '市',
                align: 'center',
                prop: 'city',
                width: 100,
                sort: true
            },
            {
                label: '区/县',
                align: 'center',
                prop: 'county',
                width: 100,
                sort: true
            },
            {
                label: '乡镇',
                align: 'center',
                prop: 'countryName',
                width: 100,
                sort: true
            },
            {
                label: '乡镇编码',
                align: 'center',
                prop: 'countryCode',
                width: 100,
                sort: true
            },
            {
                label: '地址',
                align: 'center',
                prop: 'address',
                width: 180,
                sort: true
            },
            {
                label: '经度',
                align: 'center',
                value: 'lng',
                prop: 'lng',
                width: 80,
                sort: true
            },
            {
                label: '纬度',
                align: 'center',
                value: 'lat',
                prop: 'lat',
                width: 80,
                sort: true
            },

            {
                label: '备注',
                align: 'center',
                prop: 'remark',
                width: 200,
                sort: true
            }

        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: []
};
